module.exports = __webpack_public_path__ + "static/media/lds-logo_it.68fa0f26.svg";